export default {

    point: {

        typeName: {
            1: 'Total',
            2: 'Categories'
        },

        sourceName: {
            1: 'Original',
            2: 'Calculated'
        }

    },

    cards: {

        type: {
            summary: 'summary',
            category: 'category',
            rank: 'rank'
        }

    }

}